module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-desktop-ce51565496df2118a6e6a095ce764778.jpg";